import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './reduxStore/store'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react'
import './App.scss'
import { customConfig } from 'theme/theme'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const system = createSystem(defaultConfig, customConfig)

root.render(
  <ChakraProvider value={system}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ChakraProvider>
)
